export default class State
{

  constructor() {

    this.changed = [];
    this.elements = {};

  }

  update(withStruct)
  {

    let changed = false;

    for (let n in withStruct) {
      if (withStruct.hasOwnProperty(n)) {
        if (true === this.commit(n, withStruct[n])) {
          changed = true;
        }
      }
    }

    return changed;

  }

  commit(field, value) {

    if (this.elements.hasOwnProperty(field)) {
      if (this.elements[field] === value) {
        return false;
      }
    }

    this.elements[field] = value;

    return true;

  }

  isChanged() {

    return (this.changed.length > 0);

  }

  isSingleItemChanged(item) {

    return this.changed.includes(item);

  }

  resetChanges()
  {
    this.changed = [];
  }

}


let state = new State();

// console.log(state.update({ x : 1, y : 1}));
// console.log(state.update({ x : 1, y : 1}));
